import "./index.less";
import { ExtraAndDefaultSizes, FontWeight, Typography } from "../../../internal";
import React from "react";

export interface IAtTextProps {
    size?: ExtraAndDefaultSizes;
    weight?: FontWeight;
    children: React.ReactNode;
}

export const AtText: React.FC<IAtTextProps> = ({ size = "md", weight = "medium", children, ...otherProps }) => {
    return (
        <span
            className={`AtText size-${size}`}
            style={{
                fontSize: Typography.getFontSizePropValue(size),
                fontWeight: Typography.getFontWeightPropValue(weight),
            }}
            {...otherProps}
        >
            {children}
        </span>
    );
};
